<div class="row">
    <ng-container *ngFor="let contractModification of contractModifications">
        <div class="col-md-6 col-lg-4 col-xxl-4 col-xxxl-3 animated-col">
            <div class="contract-modification-card ccc ccc-hover" role="button" (click)="viewDetails(contractModification.contractModificationRequestId)">
                <div HJSuppress  class="card-title text-center">
                    <dynamic-field [props]="props?.ContractNumber" [canBeEmpty]="true">
                        {{contractModification.contractNumber}}
                    </dynamic-field>

                    <div class="modification-type">
                        <dynamic-field [props]="props?.DictionaryContractModificationRequestTypeName"
                            [canBeEmpty]="true">
                            <span *ngIf="reimbursementType?.code === contractModification.dictionaryContractModificationRequestTypeCode; else otherContractModificationRequest">
                                {{contractModification.dictionaryReimbursementTypeName}}
                            </span>
                            <ng-template #otherContractModificationRequest>
                                {{contractModification.dictionaryContractModificationRequestTypeName}}
                            </ng-template>
                        </dynamic-field>
                    </div>
                </div>

                <div class="card-content" *ngIf="contractModification.reimbursedAmount">
                    <div class="value-reimbursed text-center">
                        {{'contractModifications.cards.reimbursedAmount' | translate}}
                        <dynamic-field [props]="props?.ReimbursedAmount" [canBeEmpty]="true">
                            <span HJSuppress class="l-text-bold">
                                {{contractModification.reimbursedAmount | number:'0.1'}} {{contractModification.currencyCode}}
                            </span>
                        </dynamic-field>
                    </div>
                </div>

                <div class="card-content" *ngIf="contractModification.otherModificationType">
                    <div class="description-container text-center">
                        <span class="l-label-description">{{'contractModifications.cards.modificationType' | translate}}</span>
                        <dynamic-field [props]="props?.OtherModificationType" [canBeEmpty]="true">
                            <span HJSuppress class="">{{contractModification.otherModificationType}}</span>
                        </dynamic-field>

                        <dynamic-field [props]="props?.Description" [canBeEmpty]="true">
                            <span HJSuppress class="">{{contractModification.description}}</span>
                        </dynamic-field>
                    </div>
                </div>

                <div class="card-content">
                    <div class="request-date text-center">
                        {{'contractModifications.cards.requestDate' | translate}}
                        <dynamic-field [props]="props?.CreatedOn" [canBeEmpty]="true">
                            <span HJSuppress class="l-text-bold">{{contractModification.createdOn | localizedDate}}</span>
                        </dynamic-field>
                    </div>
                </div>
                <div class="status-box">
                    <dynamic-field [props]="props?.DictionaryRequestStatus" [canBeEmpty]="true">
                        <div class="status-content">
                            <div class="status-dot"
                                [ngClass]="contractModification.dictionaryRequestStatus.code === dictionaryRequestStatus.POSTED ? 'status-posted':
                                        contractModification.dictionaryRequestStatus.code === dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress':
                                        contractModification.dictionaryRequestStatus.code === dictionaryRequestStatus.RESOLVED ? 'status-resolved':
                                        contractModification.dictionaryRequestStatus.code === dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                            </div>
                            <div class="status-value">{{contractModification.dictionaryRequestStatus.value}}</div>
                        </div>
                    </dynamic-field>
              </div>
            </div>
        </div>
    </ng-container>
</div>
